"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _decorateConfigItem = require("@/api/decorate/decorateConfigItem.js");
var _popupConfig = require("@/api/popup/popupConfig.js");
var _memberManagement = require("@/api/member/memberManagement.js");
var _decorateConfig = require("@/api/decorate/decorateConfig.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CommunityBNavigationBar',
  props: {
    pageKey: {
      type: String,
      default: 'communityCenter'
    },
    moduleKey: {
      type: String,
      default: '12-1'
    },
    xcxType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      searchName: '',
      tableData: [],
      selectedItems: [],
      // 用于预览功能的选中项
      currentPage: 1,
      pageSize: 10,
      total: 0,
      drawerVisible: false,
      drawerTitle: '新增轮播',
      imagePrefix: '',
      // 预览相关数据
      previewVisible: false,
      previewImageUrl: '',
      // 页面列表数据
      pageList: [],
      formData: {
        id: null,
        title: '',
        subtitle: '',
        block: 'home',
        recommendType: 'hot',
        redirectPage: '',
        resourceId: '',
        startTime: '',
        endTime: '',
        dateRange: [],
        sort: 1,
        enabled: true,
        platforms: [1],
        cover: ''
      },
      isEdit: false
    };
  },
  created: function created() {
    // 页面加载时获取已保存的配置
    this.loadConfig();
    // 获取图片前缀
    this.getImagePrefix();
    // 获取页面列表
    this.getPageList();
  },
  methods: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取图片完整URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有url则返回空
      if (!url) return '';

      // 如果已经是完整URL则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      if (this.imagePrefix) {
        // 确保前缀末尾没有斜杠，url开头有斜杠
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础URL
      return process.env.VUE_APP_BASE_API + url;
    },
    // 获取页面列表
    getPageList: function () {
      var _getPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _popupConfig.queryPageList)();
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.data) {
                this.pageList = response.data;
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取页面列表失败:', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getPageList() {
        return _getPageList.apply(this, arguments);
      }
      return getPageList;
    }(),
    // 获取板块文本
    getBlockText: function getBlockText(block) {
      var blockMap = {
        'home': '首页',
        'activity': '活动',
        'service': '服务'
      };
      return blockMap[block] || block;
    },
    // 分页相关方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadConfig();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadConfig();
    },
    // 加载配置
    loadConfig: function () {
      var _loadConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var loadingInstance, response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              loadingInstance = null;
              _context3.prev = 1;
              if (!(!this.pageKey || !this.moduleKey)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载配置中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取配置
              _context3.next = 3;
              return (0, _decorateConfigItem.getDecorateConfigItem)(this.pageKey, this.moduleKey, this.currentPage, this.pageSize, this.searchName);
            case 3:
              response = _context3.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.records) {
                // 解析配置信息
                this.tableData = response.records.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    extra: item.extra ? JSON.parse(item.extra) : {}
                  });
                });
                this.total = response.total;
                this.pageSize = response.size;
              } else if (response.code !== 200) {
                this.$message.error(response.message || '配置加载失败!');
              }
              _context3.next = 5;
              break;
            case 4:
              _context3.prev = 4;
              _t3 = _context3["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('配置加载失败:', _t3);
              this.$message.error('配置加载失败: ' + (_t3.message || '未知错误'));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 4]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }(),
    handleSave: function handleSave() {
      this.$message.success('保存成功');
      // 保存处理逻辑
      this.loadConfig();
    },
    handlePreview: function handlePreview() {
      this.$message.info('预览功能');
      // 预览处理逻辑
    },
    handleApply: function handleApply() {
      this.$message.success('应用成功');
      // 应用处理逻辑
      this.loadConfig();
    },
    // 处理表格选择变化
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedItems = selection;
    },
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.loadConfig();
    },
    // 预览功能
    preview: function () {
      var _preview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var loadingInstance, ids, previewData, response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(this.selectedItems.length === 0)) {
                _context4.next = 1;
                break;
              }
              this.$message.warning('请至少选择一条数据进行预览');
              return _context4.abrupt("return");
            case 1:
              loadingInstance = null;
              _context4.prev = 2;
              // 获取选中数据的ID
              ids = this.selectedItems.map(function (item) {
                return item.id;
              }); // 构造预览参数
              previewData = {
                ids: ids,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                xcxType: this.xcxType,
                pageURl: "" // 设置默认页面URL，可根据实际需求调整
              }; // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '预览生成中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用预览接口
              _context4.next = 3;
              return (0, _decorateConfig.previewAdd)(previewData);
            case 3:
              response = _context4.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200) {
                // 预览成功，显示返回的图片
                if (response.data) {
                  // 检查是否有二维码URL直接返回
                  if (response.data.image && typeof response.data.image === 'string') {
                    // 如果返回了二维码URL，显示预览弹窗
                    this.previewImageUrl = response.data.image;
                    this.previewVisible = true;
                  } else {
                    this.$message.success('预览二维码生成成功');
                  }
                } else {
                  this.$message.success('预览二维码生成成功');
                }
              } else {
                this.$message.error(response.message || '预览失败!');
              }
              _context4.next = 5;
              break;
            case 4:
              _context4.prev = 4;
              _t4 = _context4["catch"](2);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('预览失败:', _t4);
              this.$message.error('预览失败: ' + (_t4.message || '未知错误'));
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[2, 4]]);
      }));
      function preview() {
        return _preview.apply(this, arguments);
      }
      return preview;
    }(),
    handleAdd: function handleAdd() {
      this.drawerTitle = '新增轮播';
      this.isEdit = false;
      this.formData = {
        id: null,
        title: '',
        subtitle: '',
        block: 'home',
        recommendType: 'hot',
        redirectPage: this.pageList.length > 0 ? this.pageList[0].pageUrl : '',
        resourceId: '',
        startTime: '',
        endTime: '',
        dateRange: [],
        sort: 1,
        enabled: true,
        platforms: [1],
        cover: ''
      };
      this.drawerVisible = true;
    },
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(row) {
        var loadingInstance, response, detailData, extraData, _t5;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              loadingInstance = null;
              _context5.prev = 1;
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取配置项详情
              _context5.next = 2;
              return (0, _decorateConfigItem.getConfigItemDetail)(row.id);
            case 2:
              response = _context5.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.data) {
                // 解析详情数据
                detailData = response.data;
                extraData = detailData.extra ? JSON.parse(detailData.extra) : {};
                this.drawerTitle = '编辑轮播';
                this.isEdit = true;
                this.drawerVisible = true;

                // 填充表单数据
                this.formData = {
                  id: detailData.id,
                  title: extraData.title || '',
                  subtitle: extraData.subtitle || '',
                  block: extraData.block || 'home',
                  recommendType: extraData.recommendType || 'hot',
                  redirectPage: extraData.redirectPage || (this.pageList.length > 0 ? this.pageList[0].pageUrl : ''),
                  resourceId: extraData.resourceId || '',
                  startTime: extraData.startTime || '',
                  endTime: extraData.endTime || '',
                  dateRange: extraData.startTime && extraData.endTime ? [extraData.startTime, extraData.endTime] : [],
                  sort: extraData.sort !== undefined ? extraData.sort : 1,
                  enabled: detailData.enable !== undefined ? detailData.enable : true,
                  platforms: extraData.platforms || [1],
                  cover: extraData.cover || ''
                };
              } else {
                this.$message.error(response.message || '加载详情失败!');
              }
              _context5.next = 4;
              break;
            case 3:
              _context5.prev = 3;
              _t5 = _context5["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('加载详情失败:', _t5);
              this.$message.error('加载详情失败: ' + (_t5.message || '未知错误'));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    handleSubmit: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.$refs.form.validate(/*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(valid) {
                  var loadingInstance, data, response, _t6;
                  return regeneratorRuntime.wrap(function (_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        if (valid) {
                          _context6.next = 1;
                          break;
                        }
                        return _context6.abrupt("return");
                      case 1:
                        // 同步日期范围到formData
                        if (_this.formData.dateRange && _this.formData.dateRange.length === 2) {
                          _this.formData.startTime = _this.formData.dateRange[0];
                          _this.formData.endTime = _this.formData.dateRange[1];
                        } else {
                          _this.formData.startTime = '';
                          _this.formData.endTime = '';
                        }
                        loadingInstance = null;
                        _context6.prev = 2;
                        data = {
                          id: _this.isEdit ? _this.formData.id : null,
                          pageCode: _this.pageKey,
                          optionCode: _this.moduleKey,
                          title: _this.formData.title,
                          enable: _this.formData.enabled,
                          extra: JSON.stringify({
                            title: _this.formData.title,
                            subtitle: _this.formData.subtitle,
                            block: _this.formData.block,
                            recommendType: _this.formData.recommendType,
                            redirectPage: _this.formData.redirectPage,
                            resourceId: _this.formData.resourceId,
                            startTime: _this.formData.startTime,
                            endTime: _this.formData.endTime,
                            sort: _this.formData.sort,
                            enabled: _this.formData.enabled,
                            platforms: _this.formData.platforms,
                            cover: _this.formData.cover
                          })
                        }; // 显示保存loading状态
                        loadingInstance = _this.$loading({
                          lock: true,
                          text: '保存中...',
                          spinner: 'el-icon-loading',
                          background: 'rgba(0, 0, 0, 0.7)'
                        });

                        // 调用后端接口保存配置
                        _context6.next = 3;
                        return (0, _decorateConfigItem.saveConfigItem)(data);
                      case 3:
                        response = _context6.sent;
                        // 关闭loading
                        if (loadingInstance) {
                          loadingInstance.close();
                        }
                        if (!(response.code === 200)) {
                          _context6.next = 5;
                          break;
                        }
                        // 保存成功后关闭对话框
                        _this.drawerVisible = false;
                        // 刷新列表数据
                        _context6.next = 4;
                        return _this.loadConfig();
                      case 4:
                        _this.$message.success(_this.isEdit ? '编辑成功' : '添加成功');
                        _context6.next = 6;
                        break;
                      case 5:
                        _this.$message.error(response.message || '保存失败!');
                      case 6:
                        _context6.next = 8;
                        break;
                      case 7:
                        _context6.prev = 7;
                        _t6 = _context6["catch"](2);
                        // 关闭loading
                        if (loadingInstance) {
                          loadingInstance.close();
                        }
                        console.error('保存失败:', _t6);
                        _this.$message.error('保存失败: ' + (_t6.message || '未知错误'));
                      case 8:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6, null, [[2, 7]]);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }(),
    handleDrawerClose: function handleDrawerClose(done) {
      this.drawerVisible = false;
    },
    // 点击图片预览区域
    handleImageClick: function handleImageClick() {
      this.$refs.fileInput.click();
    },
    // 文件选择变化
    handleFileChange: function handleFileChange(event) {
      var files = event.target.files;
      if (files.length === 0) return;
      var file = files[0];
      if (this.validateImage(file)) {
        this.uploadImage(file);
      }

      // 清空input值，允许重复选择同一文件
      event.target.value = '';
    },
    // 验证图片文件
    validateImage: function validateImage(file) {
      var isImage = file.type.startsWith('image/');
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    // 上传图片
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(file) {
        var _loading, response, imageUrl, _t7;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              // 显示上传loading状态
              _loading = this.$loading({
                lock: true,
                text: '图片上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口上传图片
              _context8.next = 1;
              return (0, _popupConfig.uploadPopupImage)(file);
            case 1:
              response = _context8.sent;
              // 关闭loading
              _loading.close();
              if (response.code === 200) {
                imageUrl = response.data;
                this.formData.cover = imageUrl;
                this.$message.success('图片上传成功!');
              } else {
                this.$message.error(response.message || '图片上传失败!');
              }
              _context8.next = 3;
              break;
            case 2:
              _context8.prev = 2;
              _t7 = _context8["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('图片上传失败:', _t7);
              this.$message.error('图片上传失败: ' + (_t7.message || '未知错误'));
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function uploadImage(_x3) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }(),
    // 删除封面图
    handleRemoveCover: function handleRemoveCover() {
      var _this2 = this;
      this.$confirm('确定要删除这张封面图吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.formData.cover = '';
        _this2.$message.success('封面图删除成功!');
      }).catch(function () {
        _this2.$message.info('已取消删除');
      });
    },
    handleDelete: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0(row) {
        var _this3 = this;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var response, _t8;
                return regeneratorRuntime.wrap(function (_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      _context9.prev = 0;
                      _context9.next = 1;
                      return (0, _decorateConfigItem.deleteConfigItem)(row.id);
                    case 1:
                      response = _context9.sent;
                      if (!(response.code === 200)) {
                        _context9.next = 3;
                        break;
                      }
                      _context9.next = 2;
                      return _this3.loadConfig();
                    case 2:
                      _this3.$message.success('删除成功!');
                      _context9.next = 4;
                      break;
                    case 3:
                      _this3.$message.error(response.message || '删除失败!');
                    case 4:
                      _context9.next = 6;
                      break;
                    case 5:
                      _context9.prev = 5;
                      _t8 = _context9["catch"](0);
                      console.error('删除失败:', _t8);
                      _this3.$message.error('删除失败: ' + (_t8.message || '未知错误'));
                    case 6:
                    case "end":
                      return _context9.stop();
                  }
                }, _callee9, null, [[0, 5]]);
              }))).catch(function () {
                _this3.$message.info('已取消删除');
              });
            case 1:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this);
      }));
      function handleDelete(_x4) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }(),
    // 切换显示状态
    handleToggleVisible: function () {
      var _handleToggleVisible = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee1(row) {
        var response, _t9;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _context1.prev = 0;
              _context1.next = 1;
              return (0, _decorateConfigItem.enableConfigItem)(row.id);
            case 1:
              response = _context1.sent;
              if (!(response.code === 200)) {
                _context1.next = 3;
                break;
              }
              _context1.next = 2;
              return this.loadConfig();
            case 2:
              this.$message.success("\u66F4\u65B0\u6210\u529F");
              _context1.next = 4;
              break;
            case 3:
              // 如果接口调用失败，恢复开关状态
              row.enable = !row.enable;
              this.$message.error(response.message || '操作失败!');
            case 4:
              _context1.next = 6;
              break;
            case 5:
              _context1.prev = 5;
              _t9 = _context1["catch"](0);
              // 如果接口调用失败，恢复开关状态
              row.enable = !row.enable;
              console.error('操作失败:', _t9);
              this.$message.error('操作失败: ' + (_t9.message || '未知错误'));
            case 6:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this, [[0, 5]]);
      }));
      function handleToggleVisible(_x5) {
        return _handleToggleVisible.apply(this, arguments);
      }
      return handleToggleVisible;
    }()
  }, "handlePreview", function () {
    var _handlePreview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee10(row) {
      var _loading2, response, _t0;
      return regeneratorRuntime.wrap(function (_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            // 显示预览loading状态
            _loading2 = this.$loading({
              lock: true,
              text: '预览中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            }); // 调用后端接口预览配置 第二个参数小程序标识
            _context10.next = 1;
            return (0, _decorateConfigItem.generateQrCode)(row.id, this.xcxType);
          case 1:
            response = _context10.sent;
            // 关闭loading
            _loading2.close();
            if (response.code === 200) {
              // 预览成功，显示返回的图片
              if (response.data && response.data.image) {
                // 显示预览弹窗
                this.previewImageUrl = response.data.image;
                this.previewVisible = true;
              } else {
                this.$message.success('预览成功');
              }
            } else {
              this.$message.error(response.message || '预览失败!');
            }
            _context10.next = 3;
            break;
          case 2:
            _context10.prev = 2;
            _t0 = _context10["catch"](0);
            // 关闭loading
            if (loading) {
              loading.close();
            }
            console.error('预览失败:', _t0);
            this.$message.error('预览失败: ' + (_t0.message || '未知错误'));
          case 3:
          case "end":
            return _context10.stop();
        }
      }, _callee10, this, [[0, 2]]);
    }));
    function handlePreview(_x6) {
      return _handlePreview.apply(this, arguments);
    }
    return handlePreview;
  }()), "handlePreviewClose", function handlePreviewClose() {
    this.previewVisible = false;
    // 释放图片URL对象
    if (this.previewImageUrl) {
      URL.revokeObjectURL(this.previewImageUrl);
      this.previewImageUrl = '';
    }
  }), "beforeDestroy", function beforeDestroy() {
    // 释放图片URL对象
    if (this.previewImageUrl) {
      URL.revokeObjectURL(this.previewImageUrl);
      this.previewImageUrl = '';
    }
  })
};